import { Config } from "@wagmi/core";
import { Draw } from "../models/Draw";
import { DrawInfo } from "../models/DrawInfo";
import { TicketMapper } from "../models/TicketMapper";
import { Address } from "viem";
import { createContext } from "react";
import { UserInfo } from "../models/UserInfo";
import { LotteryStatistics } from "../models/LotteryStatistics";
import { Charity } from "../models/Charity";
import { PlayerStatistics } from "../models/PlayerStatistics";
import { HistoryFilter } from "../models/HistoryFilter";

export type PlayerDataContextType = {
  isMiniApp: boolean;
  connectWallet: () => Promise<void>;
  address: Address | undefined;
  isConnecting: boolean;
  isConnected: boolean;
  config: Config;
  buying: boolean;
  withdrawingPrizes: boolean;
  withdrawingDonations: boolean;
  withdrawingRoyalties: boolean;
  isLoading: boolean;
  animating: boolean;
  updatingDraws: boolean;
  drawInfo?: DrawInfo;
  drawDate?: Date;
  isOpen: boolean;
  statistics: LotteryStatistics;
  drawsInHome: Draw[];
  drawsInHistory: Draw[];
  userInfo: UserInfo | undefined;
  ticketMappers: TicketMapper[];
  charities: Charity[];
  fetchDrawsInPage: (page: number, filter: HistoryFilter) => Promise<void>;
  setTicketMappers: React.Dispatch<React.SetStateAction<TicketMapper[]>>;
  buyTickets: (
    ticketMappers: TicketMapper[],
    referrer: Address | undefined,
    useCoupon: boolean,
  ) => Promise<void>;
  withdrawPrizes: () => Promise<void>;
  withdrawDonations: () => Promise<void>;
  withdrawRoyalties: () => Promise<void>;
  playerStatistics: PlayerStatistics;
};

export const PlayerDataContext = createContext<
  PlayerDataContextType | undefined
>(undefined);
